module.exports = __webpack_public_path__ + "static/img/mobile-1.db722a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile-1.png
// module id = 73
// module chunks = 2